<form [formGroup]="formEmpresa">
    <div class="row">
        <div class="col-md-6">
            <label for="nit">NIT / Cédula</label>
            <input type="text" id="nit" name="nit" formControlName="nit" (change)="changeNit($event)" class="form-control">
        </div>
        <div class="col-md-6">
            <label for="nombre">Empresa / Nombre Persona Natural</label>
            <p-autoComplete formControlName="nombre" [minLength]="3" [immutable]="false" [suggestions]="getListCompanyName()" (completeMethod)="searchCompanyName($event)" (onSelect)="loadCompanyNit()" [delay]="200" [inputId]="'filter'" [width]="500" class="form-control">
            </p-autoComplete>
        </div>
    </div>
    <div class="form-group text-right m-b-0">
        <button class="btn btn-custom waves-effect waves-light" [disabled]="!this.formEmpresa.valid" (click)="addEmpresa()">Agregar</button>
    </div>
</form>
<ng-container *ngIf="getListaEmpresa().length > 0">
    <table class="row-border hover table table-hover table-centered m-0">
        <thead>
            <tr>
                <th>NIT</th>
                <th>Empresa</th>
                <th>Eliminar</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of getListaEmpresa()">
                <td>{{item.nit}}</td>
                <td>{{item.nombre}}</td>
                <td><a (click)="deleteEmpresa(item.idAdmEmpresa)" class="btn btn-sm btn-danger"><i class="mdi mdi-delete"></i></a></td>
            </tr>
        </tbody>
    </table>
</ng-container>